<template>
    <v-container>
        <v-row>
            <survey-form :surveyId="surveyId" :parentId="parentId"></survey-form>
        </v-row>
    </v-container>
</template>

<script>
    import SurveyForm from '../components/detail/survey/SurveyForm'

    export default {
        name: 'Survey',
        components: {
            SurveyForm
        },
        computed: {
            surveyId() {
                return this.$route.params.surveyId
            },
            parentId() {
                return this.$route.params.parentId
            }
        },
        created() {
            this.$store.dispatch('getAllSurveys')
        }
    };
</script>
